var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "not-found-container d-flex flex-row align-items-center" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "12", md: "6" } },
                [
                  _c("img", {
                    attrs: {
                      src: require("@Shared/@Assets/img/application-missing.png"),
                      alt: _vm.$t("global.messages.pageNotFound"),
                    },
                  }),
                  _vm._v(" "),
                  _c("h1", [
                    _vm._v(
                      _vm._s(_vm.$t("global.messages.pageNotFound")) + " :("
                    ),
                  ]),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("global.messages.pageDoesNotExists")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary mt-3",
                      attrs: { to: "dashboard" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("global.actions.takeMeBack")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }